var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "meta"
  }, [_c('div', {
    staticClass: "meta_row"
  }, [_c('article', {
    staticClass: "meta_col"
  }, [_c('span', {
    staticClass: "meta_label"
  }, [_vm._v("Name")]), _c('span', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.blockchain.name) + " ")])]), _c('article', {
    staticClass: "meta_col"
  }, [_c('span', {
    staticClass: "meta_label"
  }, [_vm._v("VM ID")]), _c('span', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.blockchain.vmID) + " ")])])]), _c('div', {
    staticClass: "meta_row"
  }, [_c('article', {
    staticClass: "meta_col"
  }, [_c('span', {
    staticClass: "meta_label"
  }, [_vm._v("Validator")]), _c('span', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.validatorsCount) + " ")])]), _c('article', {
    staticClass: "meta_col"
  }, [_c('span', {
    staticClass: "meta_label"
  }, [_vm._v("ID")]), _c('span', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.blockchain.id) + " ")])])]), _c('div', {
    staticClass: "meta_row"
  }, [_c('article', {
    staticClass: "meta_col"
  }, [_c('span', {
    staticClass: "meta_label"
  }, [_vm._v("Subnet")]), _c('span', {
    staticClass: "meta_value"
  }, [_vm._v(" " + _vm._s(_vm.blockchain.subnetID) + " ")])]), _c('article', {
    staticClass: "meta_col"
  }, [_c('span', {
    staticClass: "meta_label"
  }, [_vm._v("Indexed")]), _c('span', {
    staticClass: "meta_value"
  }, [_c('Indexed', {
    attrs: {
      "indexed": _vm.blockchain.indexed,
      "not-indexed-label": true
    }
  })], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }